<template>
    <FormDialog
        :is-visible="isVisible" @abort="finish" @save="save"
        :title="model?.id ? 'Изменение группы' : 'Новая группа'"
    >
        <DeviceGroupForm v-if="model" v-model="model" :errors="errors" />
    </FormDialog>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import Editor from '@/mixins/Editor'
import FormDialog from '@/components/common/FormDialog.vue'
import DeviceGroupForm from '@/components/forms/DeviceGroupForm.vue'
import {DeviceGroup, DeviceGroupDraft} from '@/models/DeviceGroup'

@Component({
    components: {DeviceGroupForm, FormDialog},
})
export default class DeviceGroupEditor extends Editor<DeviceGroup, DeviceGroupDraft>
{
    async saveModel(group: DeviceGroupDraft): Promise<DeviceGroup> {
        return await this.api.setDeviceGroup(group)
    }

    getModelSavedMessage(group: DeviceGroup): string {
        return `Группа «${group.name}» сохранена`
    }
}
</script>
